module.exports = __webpack_public_path__ + "1ac3c5d66155a4300f2c8895703a4ca0.png";